import React, { useState, useEffect} from 'react';
import {Router, Route, Switch} from 'react-router-dom';
import '@aws-amplify/ui-react/styles.css';
import history from './history';

import {useAccount} from '@azure/msal-react';
import {getTheme} from "./helper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import HomeEntra from "./HomeEntra";

import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { BrowserUtils } from "@azure/msal-browser";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

import {jwtDecode} from "jwt-decode";
import {Grid} from "@mui/material";

export function AppEntra(props) {

    const [userDisplayName, setUserDisplayName] = useState('');
    const { instance, accounts, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const theme = getTheme()
    const secondaryColour =  theme?.palette?.secondary?.main || "#808080"
    const [accessToken, setAccessToken] = useState(null)
    const [accessTokenExpiry, setAccessTokenExpiry] = useState(null)

    //scopes: ["https://graph.microsoft.com/User.Read"],
    //scopes: ["User.Read"]
    const scopes = [window.REACT_APP_ENTRA_SCOPES]; // ["api://1a62e127-73f0-4c11-b2b1-502af12636c9/access_as_user"]


    useEffect(() => {

        if (inProgress !== "none") return;
        if (!accounts.length) return;

        const active = instance.getActiveAccount();

        if (!active) instance.setActiveAccount(accounts[0]);


        const tokenRequest = {
            account: accounts[0],
            scopes: scopes
        }

        instance.acquireTokenSilent(tokenRequest).then((response) => {
            console.log('inProgress=', inProgress)
            console.log('acquireTokenSilent response = ', response)

            if (response) {

                setAccessToken(response.accessToken)
                setAccessTokenExpiry(response.expiresOn)

                const accessTokenDecoded = response.accessToken && jwtDecode(response.accessToken);
                console.log('accessTokenDecoded=', accessTokenDecoded)

            }

        }).catch(async (e) => {

            console.log('exception', e)
            // exception InteractionRequiredAuthError: interaction_required: AADSTS160021: Application requested a user session which does not exist. Trace ID: 4898ef41-e629-4dc5-974f-96ec5a464800 Correlation ID: 019d774c-2dc5-7d61-8c9e-7143091f06fe Timestamp: 2026-04-10 12:09:34Z

            if (e instanceof InteractionRequiredAuthError) {
                //Catch interaction_required errors and call interactive method to resolve
                return instance.acquireTokenRedirect(tokenRequest);
            }

            throw e;
        });
    }, [inProgress, accounts]);

    console.log ('inProgress=', inProgress)

    const account = useAccount()
    const idToken = account?.idToken;
    const idTokenDecoded = idToken && jwtDecode(idToken);
    console.log ('idTokenDecoded=', idTokenDecoded)
    console.log ('account=', account)
    const roles = (idTokenDecoded && idTokenDecoded.roles) ? idTokenDecoded.roles : ["Everyone"];
    console.log ('ROLES=', roles)

    let user = {
        roles: roles,
        userName: account?.name,
        email: account?.username,
        accessToken: accessToken,
        accessTokenExpiry : accessTokenExpiry
    }

    console.log ('user = ' , user)

    const logout = async () => {
        const activeAccount = instance.getActiveAccount();
        console.log('activeAccount=', activeAccount)

        // alert ('logout - debug - check activeAccount')
        // debugger


        const localLogoutOnly = false;

        if (localLogoutOnly) {
            await instance.logout({
                account: activeAccount,
                logoutType: "local",   // ⬅ Prevents Azure AD redirect & prompts //TODO still prompts for which account
            });

            // redirect user to your app’s login page afterward
            window.location.href = "/";

        } else  {
            await instance.logoutRedirect({
                account: activeAccount,
                onRedirectNavigate: () => !BrowserUtils.isInIframe(),
            }).catch((e) => {
                console.error("An error occurred during logout:", e);
            });
        }
    }

    const handleLogin = async () => {
        try {
            try {
                //try silent login
                await instance.ssoSilent({
                    scopes: scopes
                });

            } catch (error) {
                console.log("Silent login failed " + error + "Trying redirect login...");
                await instance.loginRedirect({
                    scopes: scopes
                });
            }

        } catch (error) {
            alert(`Login failed. Please try again. ${error.message}`);
        }
    }

    const loginComplete = !!(isAuthenticated && accessToken);

    const showProgressBar = inProgress !== "none" || (isAuthenticated ===  true && inProgress === 'none' && !accessToken)

    console.log('****',
        'loginComplete = ', loginComplete,
        'showProgressBar=', showProgressBar,
        'isAuthenticated = ', isAuthenticated,
        'inProgress =', inProgress,
        'accessToken=', accessToken,
         'showProgressBar=', showProgressBar)



    return (
        <div>
            {
                loginComplete ?
                <div>
                    <Router history={history}>
                        <Switch>
                            <Route exact path="/" render={props => <HomeEntra {...props}  user={user} logout={logout}  launchDashboard={false} />} />
                            <Route exact path="/debug" render={props => <HomeEntra {...props}   user={user} logout={logout}  launchDashboard={false} />} />
                            <Route exact path="/dashboard" render={props => <HomeEntra {...props}   user={user} logout={logout}   launchDashboard={true} />} />
                            <Route exact path="/file/:id" render={props => <HomeEntra {...props}  user={user} logout={logout}    launchDashboard={false} />} />
                            <Route exact path="/upload/:workspace" render={props => <HomeEntra {...props}  user={user} logout={logout}  launchDashboard={false} />} />
                            <Route exact path="/folder/:folderId" render={props => <HomeEntra {...props}   user={user} logout={logout}   launchDashboard={false}/>} />
                            <Route exact path="/search" render={props => <HomeEntra {...props}  user={user} logout={logout}  launchDashboard={false}/>} />
                        </Switch>
                    </Router>

                </div> :

                    showProgressBar ?

                        <LinearProgress sx={{
                        backgroundColor: "#e0e0e0", // track color
                        "& .MuiLinearProgress-bar": {backgroundColor: secondaryColour} // bar color
                    }}/> :

                    <Grid container spacing={0} justifyContent="center"
                          sx={{ minHeight: '100vh', paddingTop: '150px' , paddingBottom: '150px', backgroundColor: '#F1F1F1' }}>
                        <Grid item xs={3} style={
                            {textAlign:'center',
                                backgroundColor: '#FFF',
                                padding: '40px',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                maxWidth: '440px',
                                maxHeight: '360px'
                        }}>
                            <img src={window.location.origin + '/images/authlogo.png'} alt="logo"
                                 style={{display: "block", margin: "0 auto", marginBottom: '32px', marginTop: '32px', maxHeight: "80px"}}/>
                            <Typography variant="h5" gutterBottom style={{paddingBottom: '32px'}}>{window.REACT_APP_APP_TITLE}</Typography>
                            <Button variant='contained' style={{backgroundColor: secondaryColour}} onClick={() => handleLogin()}>
                                Login
                            </Button>
                        </Grid>
                    </Grid>


            }

    </div>
    )
}
